import { Children, Fragment, isValidElement } from "react";
import { HeroSlide } from "./HeroSlide.js";
function collectSlideChildren(nodes) {
    const slides = [];
    Children.forEach(nodes, (child)=>{
        if (!isValidElement(child)) return;
        if (child.type === HeroSlide) return void slides.push(child);
        if (child.type === Fragment) slides.push(...collectSlideChildren(child.props.children));
    });
    return slides;
}
function normalizeSlideChildren(children) {
    return collectSlideChildren(children);
}
export { normalizeSlideChildren };
